import { validateGridSearch } from "@/components/composite/data-grid";
import { createFileRoute } from "@tanstack/react-router";
import { TemplatesPage } from "./-templates/templates.page";

export const Route = createFileRoute("/content/templates/")({
  validateSearch: validateGridSearch,
  component: TemplatesPage,
});
